/**
 * X201 (R81 L4): a player's initials for their avatar when there is no photo. The API's `initials` when it sent them;
 * else from first / last name; else from the full name's first and last words (the ladder's waiting area rows carry only
 * names, and drew a bare person icon). '' when there is no name at all.
 */
export function playerInitials(player) {
  const given = String(player?.initials ?? '').trim();
  if (given) return given;
  const first = String(player?.firstName ?? '').trim();
  const last = String(player?.lastName ?? '').trim();
  if (first || last) return (first.charAt(0) + last.charAt(0)).toUpperCase();
  const words = String(player?.fullName ?? '').trim().split(/\s+/).filter(Boolean);
  if (!words.length) return '';
  return (words[0].charAt(0) + (words.length > 1 ? words[words.length - 1].charAt(0) : '')).toUpperCase();
}
